import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { TabsTagsDesktop as TabsTag } from '@alfa-bank/site-tabs/tabs-tags-desktop';
import { Tab } from '@alfa-bank/site-tabs/tab';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { TextDesktop } from '@alfa-bank/site-text-v2/desktop';

import { OfficeDeliveryDesktop as OfficeDelivery } from '../components/office-delivery/desktop';
import { NoDeliveryBlock } from '../components/no-delivery-block/desktop';
import { DaySlots } from '../components/dayslots/desktop';
import { DeliveryForm as Component } from '../delivery-form';
import type { TDeliveryForm, IDeps } from '../models';

import styles from './desktop.css';

const textPreset: IDeps['textPreset'] = {
    title: 'small',
};

const marginsPreset: IDeps['marginsPreset'] = {
    titleMargin: { marginBottom: 24, marginTop: 0 },
    alertMargin: { marginTop: 40 },
};

export const DeliveryFormDesktop = createWidget<IDeps, TDeliveryForm>({
    NoDeliveryBlock,
    DaySlots,
    styles,
    textPreset,
    marginsPreset,
    TabsTag,
    Block,
    Tab,
    OfficeDelivery,
    Text: TextDesktop,
})(Component);
